/* eslint-disable no-param-reassign */
export default {
  methods: {
    /**
     * 清除对象的指定 key 值
     * clearBy({name:'wang', lastName: 'jj'}, 'name'); // {name: '', lastName: 'jj'}
     * @param {*} obj
     * @param {*} keys
     */
    clearBy(obj, ...keys) {
      Object.keys(obj)
        .filter(key => keys.includes(key))
        .forEach((key) => {
          obj[key] = '';
        });
    },
  },
};
